import React from "react";
import { FONTS } from "../constants/Fonts";
import { IMAGE_CONSTANTS } from "../constants/ImageConstans";

const ValidatingClaimModal = ({
  open
}) => {
  if (!open) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <h2 style={styles.title}>{'Game Paused'}</h2>

        <img
          src={IMAGE_CONSTANTS.V2_GAME_PAUSE}
          alt="Game Paused"
          style={styles.image}
        />

        <p style={styles.gradientText}>{'Validating user claims...'}</p>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    background: `url(${IMAGE_CONSTANTS.BLUR_BACKGROUND}) center center / cover no-repeat`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
  },

  modal: {
    textAlign: "center",
    userSelect: "none",
    height: "600px",
    width: "600px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#121212",
    borderRadius: "20px",
    padding: "20px",
  },

  title: {
    color: "#ffffff",
    fontSize: "31px",
    fontWeight: 600,
    marginBottom: "10px",
    fontFamily: FONTS.MONTSERRAT_MEDIUM,
  },

  image: {
    width: "306px",
    height: "306px",
    marginBottom: "10px",
    objectFit: "contain",
  },

  gradientText: {
    fontSize: "31px",
    fontWeight: 600,
    background: "linear-gradient(90deg, #FFDE3F 0%, #5FE72EB2 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    fontFamily: FONTS.MONTSERRAT_MEDIUM,
  },
};

export default ValidatingClaimModal;
